module.exports = __webpack_public_path__ + "static/media/favicon.e1320a3a.png";